module.exports = __webpack_public_path__ + "static/media/main idea.1378e60d.mp3";